
















































import Vue from 'vue';
import { mapActions } from 'vuex';
import { isEqual } from 'lodash';

import ZenButton from '@reciprocity/button';

import { BMedia } from 'bootstrap-vue';
import { AuthMode, AuthenticationSettings } from '../types';

export default Vue.extend({
  name: 'SSOListing',
  components: {
    ZenButton,
    BMedia,
  },
  props: {
    authenticationSettings: {
      type: Object as () => AuthenticationSettings,
      default: {},
      required: true,
    },
  },
  computed: {
    onlySAMLconfigured(): boolean {
      return isEqual(this.authenticationSettings.selectedAuthModes, [AuthMode.SAML]);
    },
    samlSettingsButtonLabel(): string {
      return this.authenticationSettings.samlConfigurationReady ? 'Edit Settings' : 'Configure';
    },
  },
  methods: {
    ...mapActions({ showAlert: 'alerts/show' }),
    configureGoogle() {
      alert('this opens up Google configuration');
    },
    configureSaml() {
      if (
        this.onlySAMLconfigured &&
        !(
          this.authenticationSettings.overrideEnableStandaloneLogin ||
          this.authenticationSettings.overrideEnableGoogleLogin
        )
      ) {
        this.showAlert({
          type: 'warning',
          title: 'Heads up!',
          message: 'You should setup another authentication method if you want to edit the SAML 2.0 settings',
        });
      } else {
        this.$router.push({
          name: 'authenticationSettingsSaml',
          params: {
            tab: 'settings',
          },
        });
      }
    },
    configureSamlGroups() {
      this.$router.push({
        name: 'samlSettings',
      });
    },
  },
});
